module.exports = __webpack_public_path__ + "static/media/inside-quranic.779ded0f.png";